export enum BuilderType {
  resumeBuilder = 'builder',
  coverLetterBuilder = 'cl_builder',
}

export interface IProps {
  isOnline: boolean
  builderType: BuilderType
}
